import React from "react";
import { Card, CardContent } from "@material-ui/core";

import Header from "../styles-forms/Header";

const ContainerForm = ({ children, documento, footer = null }) => {
  return (
    <>
      <Header documento={documento} position={"center"} />
      <div
        className="gd-review-container"
        style={{
          padding: "0 40px 48px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          zIndex: 5,
          maxWidth: "1440px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Card
          className="gd-review-card mb-4"
          style={{
            width: "100%",
            maxWidth: "920px",
            borderRadius: "24px",
            overflow: "hidden",
          }}
        >
          <CardContent
            className="gd-review-content"
            style={{ padding: 0 }}
          >
            {children}
          </CardContent>
        </Card>
        {footer}
      </div>
    </>
  );
};

export default ContainerForm;
